// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7dad46a6","796":"23207f94"}[chunkId] + ".chunk.js";
};